import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export enum ERowsPerPageOptions {
  S = 10,
  M = 25,
  L = 50,
  XL = 100,
}

function usePageableCollection(
  initialState = {
    pageSize: ERowsPerPageOptions.S,
    currentPage: 0,
  },
) {
  const [currentPage, setCurrentPage] = useState(initialState.currentPage);
  const [pageSize, setPageSize] = useState(initialState.pageSize);

  useEffect(() => {
    setCurrentPage(initialState.currentPage);
  }, [initialState.currentPage]);

  useEffect(() => {
    setPageSize(initialState.pageSize);
  }, [initialState.pageSize]);

  const { current: rowsPerPageOptions } = useRef([
    ERowsPerPageOptions.S,
    ERowsPerPageOptions.M,
    ERowsPerPageOptions.L,
    ERowsPerPageOptions.XL,
  ]);

  const onPageSizeChange = useCallback((limit: ERowsPerPageOptions) => setPageSize(limit), []);
  const onPageChange = useCallback((currentPage: number) => setCurrentPage(currentPage), []);

  return useMemo(
    () => ({
      pageSize: pageSize,
      currentPage,
      rowsPerPageOptions,
      onPageSizeChange,
      onPageChange,
    }),
    [pageSize, currentPage, onPageSizeChange, onPageChange, rowsPerPageOptions],
  );
}

export default usePageableCollection;
